import React, { Component } from 'react';
import { SizeMe } from 'react-sizeme';
import cx from 'classnames';

import { Text, Link, Image, List, Button, FeatureToolTip } from '../../../ui-kit';
import { mediaSizes, STOCK_FILTERS, ADVANCED_STOCK_FILTERS, STOCK_ASSETS_HELP, stockLibraryTerms } from '../constants';
import StockAssetModal from './StockAssetModal';
import StockAssetsListCard from './AssetsList/components/StockAssetsListCard';
import { BrowseStockAssetsImage } from '../../../assets/images';
import ShutterStockModal from '../../ShutterStockModal';

import '../styles/_library.scss';

































const SEARCH_FILTER = {
  filterType: 'SEARCH',
  defaultValue: ''
};

class StockAssetLibrary extends
Component {
  constructor(props) {
    super(props);
    this.state = {
      resultsPageNumber: 1,
      currentSearchTerm: '',
      loading: false,
      stockAssetsData: [],
      timeDelay: null,
      searchLoading: false,
      assetPreviewModalActive: false,
      assetModalData: null,
      assetModalType: '',
      appliedFilter: 'popular',
      appliedAdvancedFilterCategory: null,
      allowPagination: true,
      isShutterStockModalOpen: false
    };
  }

  componentWillUnmount() {
    const { timeDelay } = this.state;
    clearTimeout(timeDelay);
  }

  triggerEndOfPage = () => {
    const {
      currentSearchTerm,
      stockAssetsData,
      allowPagination
    } = this.state;

    if (allowPagination) {
      this.setState({ allowPagination: false });
      if (stockAssetsData.length !== 0) this.fetchStockAssets(currentSearchTerm, false);
    }
  };

  toggleAssetModal = (clearData) => {
    const { assetPreviewModalActive } = this.state;
    this.setState({ assetPreviewModalActive: !assetPreviewModalActive });

    if (clearData) {
      this.setState({
        assetModalType: '',
        assetModalData: null
      });
    }
  };

  incrementPageNumber = () => {
    const { resultsPageNumber } = this.state;
    let tempNumber = resultsPageNumber;
    tempNumber += 1;
    this.setState({ resultsPageNumber: tempNumber });
  };

  fetchStockAssets = async (searchTerm, newSearch) => {
    const { searchStockAssets, isShutterStockUnlimited, enableAdobeStock } = this.props;
    const {
      stockAssetsData,
      resultsPageNumber,
      appliedFilter,
      appliedAdvancedFilterCategory
    } = this.state;

    this.setState({ loading: true });

    let stockAssets = [];
    if (newSearch) {
      this.setState({
        resultsPageNumber: 2,
        stockAssetsData: []
      });
    } else {
      this.incrementPageNumber();
      stockAssets = stockAssetsData;
    }

    const searchParams = {
      query: searchTerm,
      // Shutterstock's API can only handle 20 randomly organized videos at a time, apparently.
      perPage: appliedFilter === 'random' ? 20 : 50,
      page: newSearch ? 1 : resultsPageNumber,
      sort: appliedFilter,
      category: appliedAdvancedFilterCategory,
      source: enableAdobeStock ? 'adobe' : null
    };

    const { data = {}, error } = await searchStockAssets({
      parameters: searchParams,
      isShutterStockUnlimited
    });

    if (error || !data) {
      return void this.setState({ loading: false });
    }

    data.searchStockAssets.map((assetItem) => {
      const {
        id,
        duration,
        description,
        contributor,
        aspectRatio,
        mediaType,
        source,
        cost,
        assets: { previewMp4, thumbMp4, thumbJpg }
      } = assetItem;
      const tempAsset = {
        id,
        name: 'Stock Asset',
        typeIcon: 'video',
        thumbnailUrl: thumbJpg,
        previewUrl: previewMp4,
        thumbUrl: thumbMp4,
        assetType: mediaType,
        source,
        assetOrigin: source,
        duration,
        description,
        contributor: contributor.id,
        aspectRatio,
        cost
      };
      return stockAssets.push(tempAsset);
    });

    this.setState({
      stockAssetsData: stockAssets,
      searchLoading: false,
      loading: false,
      allowPagination: true
    });
  };

  resetSearchTimer = (searchTerm) => {
    const { timeDelay } = this.state;
    clearTimeout(timeDelay);
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({
        searchLoading: true,
        stockAssetsData: []
      });
    }, 800);
    const delayTimer = setTimeout(() => {
      this.fetchStockAssets(searchTerm, true);
    }, 1000);
    this.setState({ timeDelay: delayTimer });
  };

  handleSearchFilterChange = (e) => {
    const searchTerm = e.searchTerm.toLowerCase().trim();
    const appliedFilter = e.filters.status;
    this.setState({
      currentSearchTerm: searchTerm,
      appliedFilter
    });
    this.resetSearchTimer(searchTerm);
  };

  onAdvancedFiltersChange = async (appliedFilters) => {
    const { currentSearchTerm } = this.state;
    const { CATEGORY } = appliedFilters;
    let category = null;
    if (CATEGORY) {[category] = [CATEGORY[0]];}
    await this.setState({
      appliedAdvancedFilterCategory: category,
      stockAssetsData: [],
      loading: true
    });
    this.fetchStockAssets(currentSearchTerm, true);
  };

  handleCheckboxClick = (asset) => {
    const { addGridListItem, shutterstockAccess, showShutterstockAssets } = this.props;
    return !shutterstockAccess && showShutterstockAssets ?
    this.setState({ isShutterStockModalOpen: true }) :
    addGridListItem(asset);
  };

  showStockAssetModal = (item) => {
    const option = {
      asset: item,
      type: 'details'
    };
    this.handleCardOptionClick(option);
  };

  toggleShutterStockModal = () => {
    const { isShutterStockModalOpen } = this.state;

    this.setState({ isShutterStockModalOpen: !isShutterStockModalOpen });
  };

  handleCardOptionClick = (action) => {
    const { isProjectBrief, shutterstockAccess, showShutterstockAssets } = this.props;
    const { assetPreviewModalActive } = this.state;
    const { asset, type } = action;

    if (type === 'add' && !shutterstockAccess && showShutterstockAssets) {
      this.toggleAssetModal(true);
      return this.setState({ isShutterStockModalOpen: true });
    }

    if (type === 'details') {
      this.setState({
        assetModalData: asset,
        assetModalType: type
      });
    }

    if (type === 'add' && isProjectBrief) {
      asset.checkedState = true;
      this.handleCheckboxClick(asset);
      this.toggleAssetModal(true);
    } else if (type === 'add') {
      this.setState({
        assetModalData: asset,
        assetModalType: type
      });
    }

    if (!assetPreviewModalActive) {
      this.toggleAssetModal(false);
    }

    return null;
  };

  handleCardVideoHover = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false });
    }, 10);
  };

  closeAddAssetToPoject = () => {
    this.toggleAssetModal(true);
  };

  ctaClick = () => {
    window.open(STOCK_ASSETS_HELP, '_blank');
  };

  renderCardItem = (
  asset,
  selectedDrawerItemIds,
  isProjectBrief,
  loading,
  shutterstockAccess) =>
  <StockAssetsListCard
    shutterstockAccess={shutterstockAccess}
    item={asset}
    hideCardDetails={isProjectBrief}
    handleCardClick={() => this.showStockAssetModal(asset)}
    handleCheckboxClick={() => this.handleCheckboxClick(asset)}
    handleOptionClick={(action) => this.handleCardOptionClick(action)}
    handleVideoHover={() => this.handleCardVideoHover()}
    checkedState={selectedDrawerItemIds.includes(asset.id)}
    loading={loading} />;



  renderNoDataPlaceholder = () =>
  <div style={{ textAlign: 'center' }}>
      <Image
      width={380}
      height={230}
      backgroundSize="contain"
      defaultImageIcon="faq"
      imageUrl={BrowseStockAssetsImage} />

      <Text noMargin centered placeholder heading3>
        Use the search and filter options above to
        <br />
        browse our wide range of royalty-free stock
        <br />
        videos and add them to your projects
        <br />
        <br />
      </Text>
      <Link className="video-description-cta" onClick={() => this.ctaClick()}>
        Need Help?
      </Link>
    </div>;


  renderStockAssetsTerms = () =>
  <div className="stock-library--helper">
      <FeatureToolTip
      iconName="info"
      iconColor="black"
      iconSize={15}
      className="stock-library--helper__tooltip">

        <Text highlighted>Terms of Use - Digital</Text>
        <ul className="stock-library--helper__tooltip--terms">
          {stockLibraryTerms.map((it) =>
        <li><Text label>{it}</Text></li>
        )}
        </ul>
      </FeatureToolTip>
      <Text className="stock-library--helper__text">
        Terms of Use - Digital
      </Text>
    </div>;


  render() {
    const {
      history,
      createOrgStockAssets,
      getFilteredVideos,
      updateVideoAtomic,
      selectedDrawerItemIds,
      isProjectBrief,
      shutterstockAccess,
      enableAdobeStock,
      drawerOpen
    } = this.props;

    const {
      stockAssetsData,
      searchLoading,
      assetPreviewModalActive,
      assetModalType,
      assetModalData,
      loading,
      allowPagination,
      isShutterStockModalOpen
    } = this.state;

    return (
      <div className={cx('library stock-library', { 'drawer-open': drawerOpen })}>
        <SizeMe>
          {({ size }) =>
          <>
              {assetPreviewModalActive &&

            <StockAssetModal
              toggleAssetModal={() => this.toggleAssetModal(true)}
              handleCardOptionClick={(action) => this.handleCardOptionClick(action)}
              closeAddAssetToPoject={() => this.closeAddAssetToPoject()}
              assetModalData={assetModalData}
              assetModalType={assetModalType}
              createOrgStockAssets={createOrgStockAssets}
              getFilteredVideos={getFilteredVideos}
              updateVideoAtomic={updateVideoAtomic} />}



              <div
              className={cx(
                'library-asset-list',
                'column',
                {
                  'library-asset-list--small': size.width < mediaSizes.small
                }
              )}>

                <List
                autoHeight
                loading={searchLoading}
                history={history}
                renderCardItem={
                (asset) => this.renderCardItem(
                  asset,
                  selectedDrawerItemIds,
                  isProjectBrief,
                  loading,
                  shutterstockAccess
                )}
                data={stockAssetsData}
                filters={STOCK_FILTERS}
                renderNoDataPlaceholder={this.renderNoDataPlaceholder}
                advancedFilters={ADVANCED_STOCK_FILTERS}
                onFiltersChange={(searchTerm) => this.handleSearchFilterChange(searchTerm)}
                onAdvancedFiltersChange={(filters) => this.onAdvancedFiltersChange(filters)}
                options={[]}
                searchFilter={SEARCH_FILTER}
                listKey="stockAssetId"
                searchSuffix={
                !enableAdobeStock &&
                <Text caption ellipsisOverflow>POWERED BY SHUTTERSTOCK</Text>}

                renderSearchBottomInfo={this.renderStockAssetsTerms} />

              </div>
              {stockAssetsData.length ?

            <div style={{ paddingBottom: 150, paddingTop: 80, width: '100%', display: 'flex', justifyContent: 'center' }} className="load-more">
                    <Button onClick={() => this.triggerEndOfPage()} className="load-more">
                      {allowPagination ? 'Load More' : 'Loading...'}
                    </Button>
                  </div> :
            null}


              {isShutterStockModalOpen &&
            <ShutterStockModal
              visible={isShutterStockModalOpen}
              onClose={this.toggleShutterStockModal} />}


            </>}

        </SizeMe>
      </div>);

  }
}

export default StockAssetLibrary;